module.exports = __webpack_public_path__ + "img/second-2.ddd16d50.webp";